import React from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { VariableUser } from './VariableUser';
import { postUser } from '../../store/Actions/ActionUser';
import '../../assets/styles/StylePopup.css'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../components/general/general-component/abstruct-component/AbstructForm';

function AddUser({ open, setOpen }) {
    let { mode, dispatch,langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    const { state, setStateCustom, setLoad } = VariableUser()
    const Submit = e => {
        e.preventDefault()
        dispatch(postUser(state, setLoad))
    }
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: "email", label: "email", type: "text", inputType: 'text', iconType: "envelope" },
        { name: "password", label: "password", type: "text", inputType: 'text', iconType: "key" },
        {
            name: "role", label: "Roles", type: "text", inputType: 'one_select', iconType: "role",
            options: [
                { value: "manager", label: "manager" },
                { value: "reader", label: "reader" },
                { value: "accountant", label: "accountant" },
                { value: "accounting-manager", label: "accounting-manager" },
              ]
        },
        {/*
            name: "role", label: "role", type: "text", inputType: 'select', iconType: "user",
            options: ['manager', 'reader']
    */},
    ];
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div className={`div_title_popup ${mode === 'dark' ? "darktoppopup" : "lighttoppopup"}`} >
                    <p className={`title_popup ${mode === 'dark' ? "darktext" : "lighttext"}`}  >{translate('adduser')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={Submit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
            </div>
        </RModal>
    )
}

export default AddUser